import { BackendSettings } from "../enums/BackendSettings";
import { ISettingResponseItem } from "../interfaces/setting-items/ISettingResponseItem";
import { ISettingsModel } from "../interfaces/ISettingsModel";
import { ISimpleSettingResponseItem } from "../interfaces/setting-items/ISimpleSettingResponseItem";
import { AccountSettingState } from "../enums/AccountSettingState";
import { defaultBoolSetting } from "./functions/DefaultBoolSetting.function";
import { defaultListSetting } from "./functions/DefaultListSetting.function";
import { fromListOptions } from "./functions/FromListOptions.function";
import { fromStringBool } from "./functions/FromStringBool.function";

export const settingsModelMapper = (response: ReadonlyArray<ISettingResponseItem>): ISettingsModel => {
    const settingsMap = new Map<string, ISettingResponseItem>();

    for (const setting of response) {
        settingsMap.set(setting.name, setting);
    }

    const pageSaving = settingsMap.get(BackendSettings.PageSaving);
    const embedConsent = settingsMap.get(BackendSettings.EmbedConsent);
    const languageChoice = settingsMap.get(BackendSettings.LanguageChoice);
    const grades = settingsMap.get(BackendSettings.Grades);
    const feedback = settingsMap.get(BackendSettings.Feedback);
    const comments = settingsMap.get(BackendSettings.Comments);
    const updated = settingsMap.get(BackendSettings.Updated);
    const shares = settingsMap.get(BackendSettings.Shares);
    const atlasReceipts = settingsMap.get(BackendSettings.AtlasReceipts);
    const notificationFrequency = settingsMap.get(BackendSettings.NotificationFrequency);
    const notificationTime = settingsMap.get(BackendSettings.NotificationTime) as ISimpleSettingResponseItem;

    return {
        assessment: {
            enabled: pageSaving !== undefined,
            pageSaving: pageSaving !== undefined ? fromStringBool(pageSaving) : defaultBoolSetting(false)
        },
        language: {
            enabled: true,
            languageChoice: languageChoice !== undefined ? fromListOptions(languageChoice) : defaultListSetting("en-GB")
        },
        privacy: {
            enabled: true,
            embedConsent: embedConsent !== undefined ? fromStringBool(embedConsent) : defaultBoolSetting(false)
        },
        notifications: {
            enabled: notificationFrequency !== undefined && notificationTime !== undefined,
            digestIsDisabled: false,
            settings: {
                grades: {
                    name: BackendSettings.Grades,
                    value: grades !== undefined ? grades.value : "F"
                },
                feedback: {
                    name: BackendSettings.Feedback,
                    value: feedback !== undefined ? feedback.value : "F"
                },
                comments: {
                    name: BackendSettings.Comments,
                    value: comments !== undefined ? comments.value : "F"
                },
                updated: {
                    name: BackendSettings.Updated,
                    value: updated !== undefined ? updated.value : "F"
                },
                shares: {
                    name: BackendSettings.Shares,
                    value: shares !== undefined ? shares.value : "F"
                },
                atlasReceipts: {
                    name: BackendSettings.AtlasReceipts,
                    value: atlasReceipts !== undefined ? atlasReceipts.value : "F"
                },
                notificationFrequency: {
                    name: BackendSettings.NotificationFrequency,
                    value: notificationFrequency !== undefined ? notificationFrequency.value : "Daily",
                    options: notificationFrequency !== undefined && notificationFrequency.options !== undefined ? notificationFrequency.options : []
                },
                notificationTime: {
                    name: BackendSettings.NotificationTime,
                    value: notificationTime !== undefined ? notificationTime.value : "1",
                    options: notificationTime !== undefined && notificationTime.options !== undefined ? notificationTime.options : []
                }
            }
        },
        state: {
            descriptor: AccountSettingState.Default
        }
    };
};
